



















import { Component, Vue } from 'vue-property-decorator';
import { zyScreenServer } from '@/api/installServer';
import AlarmDialogList from '@/views/dataView/ziYangDataViewBlack/rcDialog/alarmDialogList.vue';

@Component({
  components: {
    AlarmDialogList,
  },
})
export default class AlarmDialogStatic extends Vue {
  dialogVisible: any = false;
  loading: any = false;
  private tableData: any = [];

  showDialog() {
    this.tableData = [];
    this.getAlarmCountData();
    this.dialogVisible = true;
  }
  showDetailDialog(data: any) {
    const companyId: any = data.companyId;
    (this.$refs.AlarmDialogListRef as any).showDialog(companyId);
  }
  getAlarmCountData() {
    zyScreenServer
      .getAlarmStatisticData({})
      .then((res: any) => {
        if (res.data && res.data.length) {
          this.tableData = res.data;
        }
      })
      .catch((error: any) => {});
  }

  handleClose(done: any) {
    done();
  }
}
